@if (unconfirmedTicket) {
  <div class="edit-container">
    <patron-form [formGroup]="formEditTicket" role="form" class="form-horizontal h-100" novalidate>
      <div class="row">
        <div
          class="col-12 mb-1 pl-1 py-0 d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div class="d-flex align-items-center flex-wrap gap-2">
            <b class="mr-3">Problema:</b>
          </div>
          <div class="d-flex align-items-center flex-wrap gap-2">
            <div
              class="btn-group btn-group-sm problem-width-buttons"
              role="group"
              aria-label="Ajustar largura do problema">
              <button
                type="button"
                class="btn"
                [class.btn-primary]="problemWidthLevel === 1"
                [class.btn-outline-primary]="problemWidthLevel !== 1"
                (click)="setProblemWidthLevel(1)"
                aria-label="Tamanho 1"
                title="Tamanho 1">
                <span class="problem-width-icon problem-width-icon--1" aria-hidden="true">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
              <button
                type="button"
                class="btn"
                [class.btn-primary]="problemWidthLevel === 2"
                [class.btn-outline-primary]="problemWidthLevel !== 2"
                (click)="setProblemWidthLevel(2)"
                aria-label="Tamanho 2"
                title="Tamanho 2">
                <span class="problem-width-icon problem-width-icon--2" aria-hidden="true">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
              <button
                type="button"
                class="btn"
                [class.btn-primary]="problemWidthLevel === 3"
                [class.btn-outline-primary]="problemWidthLevel !== 3"
                (click)="setProblemWidthLevel(3)"
                aria-label="Tamanho 3"
                title="Tamanho 3">
                <span class="problem-width-icon problem-width-icon--3" aria-hidden="true">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
            </div>
            <div
              class="btn-group btn-group-sm ml-2"
              role="group"
              aria-label="Alternar visualização do problema">
              <button
                type="button"
                class="btn"
                [class.btn-primary]="showProblemAsMarkdown"
                [class.btn-outline-primary]="!showProblemAsMarkdown"
                (click)="setProblemViewMode('markdown')">
                <i class="bi bi-markdown mr-1"></i>
                Markdown
              </button>
              <button
                type="button"
                class="btn"
                [class.btn-primary]="!showProblemAsMarkdown"
                [class.btn-outline-primary]="showProblemAsMarkdown"
                (click)="setProblemViewMode('text')">
                <i class="bi bi-text-left mr-1"></i>
                Texto
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 mb-3 pl-1 py-0">
          <div [ngClass]="problemWidthClass">
            @if (showProblemAsMarkdown) {
              <markdown
                class="ticket-problem-markdown"
                [data]="unconfirmedTicket.problem || ''"></markdown>
            } @else {
              <span style="white-space: pre-line">{{ unconfirmedTicket.problem }}</span>
            }
          </div>
        </div>
      </div>
      <div class="card pt-3 px-3 mb-0 mx-n5">
        <div class="row align-items-start ajustMarginCard">
          <div class="col-lg-3">
            <div class="form-group row">
              <div class="col">
                <patron-select
                  [formGroup]="formEditTicket"
                  formControlName="situation"
                  [items]="ticketsSituation"
                  (onChange)="onChangeSituation()"
                  placeholder="Situação"
                  bindLabel="label"
                  label="Situação">
                </patron-select>
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="form-group row">
              <div class="col">
                <patron-select
                  [formGroup]="formEditTicket"
                  formControlName="ticketStatus"
                  placeholder="Status"
                  bindLabel="description"
                  orderBy="description"
                  label="Status"
                  modelName="ticket-statuses">
                </patron-select>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group row">
              <patron-form-field
                type="number"
                formControlName="priorityTicket"
                [formGroup]="formEditTicket"
                placeholder="Prioridade"
                label="Prioridade">
              </patron-form-field>
            </div>
          </div>
          <div class="col-auto">
            <div class="row justify-content-center mt-5">
              <patron-form-check [inputTemplate]="input" [labelTemplate]="urgente">
                <ng-template #input>
                  <input type="checkbox" id="urgentTicket" formControlName="urgentTicket" />
                </ng-template>
                <ng-template #urgente>
                  <label for="urgentTicket" [class.text-danger]="unconfirmedTicket.urgent">
                    <b>Urgente</b>
                  </label>
                </ng-template>
              </patron-form-check>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group row adjustMarginSelect">
              <div class="col">
                <patron-select
                  [formGroup]="formEditTicket"
                  formControlName="clientTicket"
                  placeholder="Clientes"
                  bindLabel="name"
                  orderBy="persons.name"
                  label="Cliente"
                  modelName="customers">
                </patron-select>
                @if (!unconfirmedTicket.customer) {
                  <div class="invalid-feedback custom-display-block">
                    Por favor selecione um cliente
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group row adjustMarginSelect">
              <div class="col">
                <patron-select
                  [formGroup]="formEditTicket"
                  formControlName="ticketSystem"
                  placeholder="Sistemas"
                  bindLabel="description"
                  orderBy="description"
                  label="Sistema"
                  modelName="systems">
                </patron-select>
                @if (!unconfirmedTicket.system) {
                  <div class="invalid-feedback custom-display-block">
                    Por favor selecione um sistema
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group row adjustMarginSelect py-0">
              <div class="col">
                <patron-select
                  [formGroup]="formEditTicket"
                  formControlName="responsible"
                  placeholder="Responsável"
                  bindLabel="name"
                  orderBy="name"
                  label="Responsável"
                  modelName="users">
                </patron-select>
                @if (!userResp) {
                  <div class="invalid-feedback custom-display-block">
                    Por favor selecione um usuário
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group adjustMarginSelect row">
              <div class="col">
                <patron-select
                  [formGroup]="formEditTicket"
                  formControlName="devTicket"
                  placeholder="Desenvolvedor"
                  bindLabel="name"
                  orderBy="name"
                  label="Desenvolvedor"
                  modelName="users">
                </patron-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-ticket-documents
        [entity]="unconfirmedTicket"
        [uploadPath]="
          'tickets/' + (unconfirmedTicket.ticket_number_teorema || unconfirmedTicket.id)
        "
        (saving)="saving.emit($event)"
        (save)="save.emit($event)"></app-ticket-documents>
    </patron-form>
  </div>
}
